// ============================================================
//  طباعة النماذج الرسمية (مرسومة بالكود — نفس ترويسة التقارير)
//  مراقبة التشغيل - محطة الصبية
//  يتطلب الشعار في: public/forms/logo.png
//  الاستخدام: import { printOfficialForm } from './officialForms';
//            printOfficialForm('leave', { employee: selectedEmployee, leave: r });
// ============================================================

const WEEKDAYS_AR = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

function splitDate(d) {
  if (!d) return { y: '', m: '', d: '' };
  const [y, m, day] = String(d).split('-');
  return { y: y || '', m: m || '', d: (day || '').slice(0, 2) };
}
const weekdayAr = (d) => {
  if (!d) return '';
  const dt = new Date(`${d}T12:00:00`);
  return Number.isNaN(dt.getTime()) ? '' : WEEKDAYS_AR[dt.getDay()];
};
const addOneDay = (d) => {
  if (!d) return '';
  const dt = new Date(`${d}T12:00:00`);
  if (Number.isNaN(dt.getTime())) return '';
  dt.setDate(dt.getDate() + 1);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
const daysBetween = (a, b) => {
  if (!a || !b) return '';
  const s = new Date(`${a}T00:00:00`), e = new Date(`${b}T00:00:00`);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return '';
  const d = Math.floor((e - s) / 86400000) + 1;
  return d > 0 ? d : '';
};
const esc = (v) => String(v == null ? '' : v).replace(/</g, '&lt;');
const displayShift = (e = {}) => ((e.shiftType === 'صباحي' || e.shift === 'M' || e.shift === 'Morning') ? 'صباحي' : (e.shift || ''));

// ترويسة رسمية موحدة لجميع النماذج المطبوعة
function headerHTML() {
  return `
  <div class="official-form-header">
    <div class="form-logo"><img src="/forms/logo.png" alt="شعار وزارة الكهرباء والماء"></div>
    <div class="form-center">
      <div class="form-center-title">مراقبة التشغيل</div>
      <div class="form-center-line"><span></span><i></i><span></span></div>
    </div>
    <div class="form-station">محطة الصبية<br>لتوليد القوى الكهربائية<br>وتقطير المياه</div>
  </div>`;
}

// صف بيانات في جدول النموذج
function row(ar, en, val) {
  return `<tr><th class="emp-label"><span class="l-ar">${ar}</span><span class="l-en">${en}</span></th><td class="emp-value">${esc(val)}</td></tr>`;
}
function dataTable(e, options = {}) {
  const fields = options.fields || [
    ['الاسم', 'Name', e.fullName],
    ['الوظيفة', 'Designation', e.jobTitle],
    ['رقم الملف', 'File No.', e.fileNo],
    ['الرقم المدني', 'Civil ID No.', e.civilID],
    ['النوبة', 'Shift', displayShift(e)],
    ['مكان العمل', 'Work site', e.workLocation]
  ];
  return `<table class="emp-table${options.centerValues ? ' center-values' : ''}"><tbody>
    ${fields.map(([ar, en, value]) => row(ar, en, value)).join('')}
  </tbody></table>`;
}

const dline = (d) => {
  const s = splitDate(d);
  return `<u>${esc(s.d || '&nbsp;&nbsp;')}</u> / <u>${esc(s.m || '&nbsp;&nbsp;')}</u> / <u>${esc(s.y || '&nbsp;&nbsp;&nbsp;&nbsp;')}</u>`;
};

function bodyLeave(e, lv) {
  return `
  <div class="title-box">طلب إجازة</div>
  <div class="addr"><span>السيد / مراقب التشغيل</span><span>المحترم</span></div>
  <div class="greet">تحية طيبة وبعد ،،،</div>
  <div class="bl">أرجو التفضل بالموافقة على منحي إجازة مدتها ( <b class="fill">${esc(lv.actualDays ?? lv.days)}</b> ) يوم</div>
  <div class="bl">اعتباراً من : ${dline(lv.startDate)} م &nbsp;&nbsp; إلى : ${dline(lv.endDate)} م</div>
  ${dataTable(e)}
  <div class="signs"><div class="sg">توقيع مهندس النوبة<div class="sgl"></div></div><div class="sg">توقيع الموظف (Sign.)<div class="sgl"></div></div></div>
  <div class="phone"><span class="circle"></span> اتصال هاتفي</div>
  <div class="foot-c">مراقب التشغيل<div class="sgl"></div></div>`;
}

function bodyExtension(e, lv) {
  // فترة التمديد: من اليوم التالي للنهاية الأصلية إلى النهاية الجديدة
  const from = lv.extended && lv.originalEndDate ? addOneDay(lv.originalEndDate) : lv.startDate;
  const to = lv.endDate;
  const days = (lv.extended && lv.originalEndDate ? daysBetween(from, to) : lv.days) || '';
  return `
  <div class="title-box">طلب تمديد إجازة</div>
  <div class="addr"><span>السيد / مراقب التشغيل</span><span>المحترم</span></div>
  <div class="greet">تحية طيبة وبعد ،،،</div>
  <div class="bl">أرجو التفضل بالموافقة على تمديد إجازتي مدتها ( <b class="fill">${esc(days)}</b> ) يوم</div>
  <div class="bl">اعتباراً من : ${dline(from)} م &nbsp;&nbsp; إلى : ${dline(to)} م</div>
  ${dataTable(e)}
  <div class="signs"><div class="sg">توقيع مهندس النوبة<div class="sgl"></div></div><div class="sg">توقيع الموظف (Sign.)<div class="sgl"></div></div></div>
  <div class="phone"><span class="circle"></span> اتصال هاتفي</div>
  <div class="foot-c">مراقب التشغيل<div class="sgl"></div></div>`;
}

function bodyEmergency(e, lv) {
  return `
  <div class="title-box">طلب إجازة عارضة</div>
  <div class="addr"><span>السيد / مراقب التشغيل</span><span>المحترم</span></div>
  <div class="greet">تحية طيبة وبعد ،،،</div>
  <div class="bl rt">يرجى العلم بأنني قد تغيبت عن العمل يوم ( <b class="fill">${esc(weekdayAr(lv.startDate))}</b> ) الموافق ${dline(lv.startDate)} م</div>
  <div class="bl rt">وذلك لظروف طارئة خاصة بي .</div>
  <div class="bl rt">لذا أرجو التفضل باحتساب ذلك اليوم إجازة عارضة .</div>
  ${dataTable(e)}
  <div class="signs"><div class="sg">توقيع مهندس النوبة<div class="sgl"></div></div><div class="sg">توقيع الموظف (Sign.)<div class="sgl"></div></div></div>
  <div class="phone"><span class="circle"></span> اتصال هاتفي</div>
  <div class="foot-c2">مراقب التشغيل<div class="sgl"></div></div>
  <div class="notes"><div class="n-t">ملاحظة :</div><div>◄ لكل موظف الحق في طلب إجازة عارضة واحدة فقط في الشهر .</div><div>◄ لكل موظف الحق في طلب أربعة طلبات إجازة عارضة في السنة .</div></div>`;
}

function bodyReturn(e, lv) {
  const opts = [['دورية', 'طارئة', 'حج'], ['طبية', 'الخدمة العسكرية', 'دورة تدريبية']];
  const optRows = opts.map(r => `<div class="opt-row">${r.map(c => `<div class="opt"><span class="o-lbl">${c}</span><span class="circle"></span></div>`).join('')}</div>`).join('');
  const startDate = lv.returnToWorkDate || addOneDay(lv.endDate);
  return `
  <div class="plain-title">نموذج مباشرة عمل</div>
  <div class="addr"><span>السيد مدير / سكرتير محطة الصبية</span><span>المحترم</span></div>
  <div class="greet">تحية طيبة وبعد ،،،</div>
  <div class="bl center">نحيطكم علماً بأن :-</div>
  ${dataTable(e, { centerValues: true, fields: [
    ['الاسم', 'Name', e.fullName],
    ['الوظيفة', 'Designation', e.jobTitle],
    ['رقم الملف', 'File No.', e.fileNo],
    ['الرقم المدني', 'Civil ID No.', e.civilID],
    ['النوبة', 'Shift', displayShift(e)]
  ] })}
  <div class="signs return-sign"><div class="sg rt">قد باشر العمل اعتباراً من تاريخ ${dline(startDate)} م</div><div class="sg">توقيع الموظف (Sign.)<div class="sgl"></div></div></div>
  <div class="bl center leave-type-line">نوع الإجازة التي تم منحها للمذكور</div>
  <div class="opts-frame">${optRows}</div>
  <div class="bl center">الإجازة التي تم منحها للمذكور ( <b class="fill">${esc(lv.actualDays ?? lv.days)}</b> ) يوم</div>
  <div class="bl center">للفترة من : ${dline(lv.startDate)} &nbsp; وحتى : ${dline(lv.endDate)}</div>
  <div class="three"><div class="t3">مكتب الدوام<div class="sgl"></div></div><div class="t3">المسؤول المباشر<div class="sgl"></div></div><div class="t3">مراقب التشغيل<div class="sgl"></div></div></div>`;
}

const CSS = `
  *{margin:0;padding:0;box-sizing:border-box}
  @page{size:A4 portrait;margin:7mm}
  html,body{background:#fff;font-family:Tahoma,Arial,"Traditional Arabic",sans-serif;margin:0;padding:0;overflow:hidden;color:#111}
  .page{width:100%;height:auto;background:#fff;page-break-after:avoid;break-after:avoid-page}
  .frame{border:2px solid #0b1f4d;padding:5mm 6mm 5mm;min-height:276mm;display:flex;flex-direction:column;overflow:hidden;color:#111;page-break-after:avoid;break-after:avoid-page}
  .official-form-header{display:grid;grid-template-columns:1fr 1fr 1fr;align-items:start;gap:12px;direction:ltr;border-bottom:2px solid #0b1f4d;padding-bottom:7px;margin-bottom:10px;color:#0b1f4d;min-height:32mm}
  .form-logo{text-align:left;direction:ltr}.form-logo img{width:34mm;max-width:100%;height:auto;display:block}
  .form-center{text-align:center;direction:rtl;padding-top:7mm}.form-center-title{font-weight:700;font-size:18px;letter-spacing:.2px}.form-center-line{display:flex;align-items:center;justify-content:center;gap:7px;margin-top:7px}.form-center-line span{width:34mm;border-top:1.5px solid #0b1f4d}.form-center-line i{width:7px;height:7px;border-radius:50%;background:#0b1f4d;display:inline-block}
  .form-station{text-align:right;direction:rtl;font-weight:700;font-size:14px;line-height:1.55;padding-top:4mm}
  .title-box{align-self:center;width:max-content;max-width:72%;margin:10px auto 8px;border:1.6px solid #0b1f4d;padding:5px 28px;font-weight:700;font-size:22px;text-align:center;overflow:hidden;color:#0b1f4d}
  .plain-title{margin:12px auto 14px;text-align:center;font-weight:700;font-size:24px;color:#0b1f4d}
  .addr{display:flex;justify-content:space-between;font-weight:600;font-size:16px;margin:10px 4px 0}
  .greet{font-weight:500;font-size:15px;margin:5px 4px 0;text-align:center}
  .bl{font-weight:500;font-size:16px;line-height:1.75;margin:6px 6px 0;text-align:center}
  .bl.rt{text-align:right}.bl.center{text-align:center}
  .fill{display:inline-block;min-width:42px;text-align:center;color:#000;font-weight:700}
  .bl u{display:inline-block;min-width:30px;text-align:center;color:#000;text-decoration:none;border-bottom:1px solid #0b1f4d;margin:0 2px;font-weight:600}
  .dtable{margin-top:10px;border-top:1.4px solid #0b1f4d}
  .t-row{display:flex;align-items:stretch;min-height:9.5mm}
  .t-label{width:25%;border:1.4px solid #0b1f4d;border-top:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:2px 4px;background:#fff;color:#0b1f4d}
  .l-ar{font-weight:600;font-size:15px;line-height:1.15}.l-en{font-weight:400;font-size:11px;color:#222}
  .t-val{flex:1;border-right:1.4px solid #0b1f4d;border-bottom:1.4px solid #0b1f4d;display:flex;align-items:center;justify-content:flex-start;min-height:9.5mm;font-size:17px;font-weight:700;color:#000;padding:0 14px;background:#fff}
  .center-values .t-val{justify-content:center;text-align:center}
  .signs{display:flex;justify-content:space-between;gap:20px;margin-top:14px;align-items:flex-start}
  .sg{text-align:center;font-weight:600;font-size:15px;flex:1}.sg.rt{text-align:right;align-self:center}
  .sgl{margin:20px auto 0;border-top:1.5px solid #111;width:72%}
  .phone{display:flex;align-items:center;gap:8px;font-weight:500;font-size:15px;margin-top:12px}
  .circle{width:13px;height:13px;border:1.3px solid #0b1f4d;border-radius:50%;display:inline-block;flex:none}
  .foot-c,.foot-c2{text-align:center;font-weight:700;font-size:17px;margin-top:auto;padding-top:15px;margin-bottom:24px;color:#0b1f4d}
  .foot-c .sgl,.foot-c2 .sgl{margin:10px auto 0;width:42%}
  .notes{margin-top:auto;padding-top:14px;font-weight:500;font-size:13px;border-top:1px solid #999;line-height:1.7}
  .n-t{text-decoration:underline;font-weight:700}
  .opts-frame{border:1.4px solid #0b1f4d;border-radius:0;padding:8px 12px;margin:8px 0;background:#fff}
  .opt-row{display:flex;justify-content:space-between;margin:6px 0;gap:8px}.opt{flex:1;display:flex;align-items:center;justify-content:center;gap:7px}.o-lbl{font-weight:500;font-size:14px;white-space:nowrap}
  .three{display:flex;justify-content:space-between;margin-top:auto;padding-top:16px;gap:30px}.t3{flex:1;text-align:center;font-weight:700;font-size:16px;color:#0b1f4d}.t3 .sgl{width:80%;margin-top:12px}
  .return-form .plain-title{margin-top:12px;margin-bottom:13px}.return-form .addr{margin-top:6px}.return-form .greet{font-weight:400}.return-form .dtable{margin-top:9px}.return-form .t-row{min-height:8.5mm}.return-form .t-label{padding:1px 4px}.return-form .l-ar{font-size:14px}.return-form .l-en{font-size:10px}.return-form .t-val{min-height:8.5mm;font-size:17px}.return-form .leave-type-line{margin-top:18px}.return-form .signs{margin-top:14px}.return-form .opts-frame{margin:7px 0 10px}.return-form .three{padding-top:10px}.return-form .t3 .sgl{margin-top:10px}

  .dtable,.t-row,.t-label,.t-val{display:unset}
  .emp-table{width:100%;border-collapse:collapse;table-layout:fixed;margin-top:10px;direction:rtl;border:1.6px solid #0b1f4d;background:#fff}
  .emp-label{width:26%;border:1.6px solid #0b1f4d;text-align:center;vertical-align:middle;padding:3px 4px;background:#fff;color:#0b1f4d;font-weight:600}
  .emp-value{border:1.6px solid #0b1f4d;text-align:center;vertical-align:middle;padding:4px 8px;background:#fff;color:#000;font-weight:700;font-size:17px;height:8.5mm;line-height:1.25}
  .center-values .emp-value{text-align:center}
  .foot-c,.foot-c2{margin-top:34px!important;margin-bottom:12px!important;padding-top:0!important}
  .three{margin-top:38px!important;padding-top:0!important}
  .return-form .three{margin-top:36px!important}
  .return-form .emp-value{height:8mm}
  .return-form .leave-type-line{margin-top:14px!important}
  .return-form .opts-frame{margin:6px 0 9px!important}
  .bl{line-height:1.55!important;margin-top:4px!important}
  .addr{margin-top:8px!important}
  .greet{margin-top:3px!important}
  .signs{margin-top:12px!important}
  .phone{margin-top:9px!important}

  /* v19.28 vertical balance: use lower A4 space instead of crowding the top */
  .emp-label span{display:block;width:100%;text-align:center}
  .emp-label .l-ar{margin-bottom:2px}
  .title-box{margin-top:16px!important;margin-bottom:12px!important}
  .plain-title{margin-top:18px!important;margin-bottom:18px!important}
  .addr{margin-top:14px!important;margin-bottom:0!important}
  .greet{margin-top:8px!important;margin-bottom:4px!important}
  .bl{margin-top:8px!important;line-height:1.7!important}
  .emp-table{margin-top:16px!important}
  .signs{margin-top:22px!important}
  .phone{margin-top:14px!important}
  .foot-c,.foot-c2{margin-top:58px!important;margin-bottom:18px!important}
  .notes{margin-top:48px!important;padding-top:12px!important}
  .return-form .plain-title{margin-top:18px!important;margin-bottom:18px!important}
  .return-form .emp-table{margin-top:16px!important}
  .return-form .signs{margin-top:20px!important}
  .return-form .leave-type-line{margin-top:26px!important}
  .return-form .opts-frame{margin:10px 0 14px!important;padding:10px 12px!important}
  .return-form .three{margin-top:58px!important}
`;

export function buildFormHTML(type, data) {
  const e = data.employee || {};
  const lv = data.leave || {};
  let body, cls = '';
  if (type === 'emergency') body = bodyEmergency(e, lv);
  else if (type === 'return') { body = bodyReturn(e, lv); cls = 'compact return-form'; }
  else if (type === 'extension') body = bodyExtension(e, lv);
  else body = bodyLeave(e, lv);

  return `<!DOCTYPE html><html lang="ar" dir="rtl"><head><meta charset="UTF-8">
  <style>${CSS}</style></head><body>
    <div class="page"><div class="frame ${cls}">${headerHTML()}${body}</div></div>
    <script>window.onload=function(){document.body.style.overflow="hidden";setTimeout(function(){window.print()},500)}<\/script>
  </body></html>`;
}

export function printOfficialForm(type, data) {
  const w = window.open('', '_blank', 'width=900,height=1200');
  if (!w) { alert('فضلاً اسمح بالنوافذ المنبثقة للطباعة'); return; }
  w.document.write(buildFormHTML(type, data));
  w.document.close();
}
